import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import { observable, action, autorun } from 'mobx';
import { observer, inject } from 'mobx-react';
import Spinner from "../Spinner";
import 'jspdf-autotable';
import MapFilterGroup from '../Map/MapFilterGroup';
import { ADMINISTRATIVE_DIVISIONS } from '../../config';
import DataTable from '../DataTable';
import moment from 'moment';
import * as storage from '../../libs/localStorage';
import { getDisplayDate } from '../../libs/date';

@inject('stationStore', 'tagStore', 'mapStore', 'reportingTemplateStore')
@observer
class MonitoringTabular extends Component {

  static contextTypes = {
    notify: PropTypes.object.isRequired,
  };

  pathname = '/monitoring/tabular';
  state = {
    stations: [],
    filteredStations: [],
    districts: [],
    provinces: [],
  }
  columns = [
    { key: 'sn', label: 'S.N.' },
    { key: 'name', label: 'NAME' },
    { key: 'identifier', label: 'IDENTIFIER' },
    { key: 'district', label: 'DISTRICT' },
    { key: 'upazila', label: 'UPAZILA' },
    { key: 'latitude', label: 'LATITUDE' },
    { key: 'longitude', label: 'LONGITUDE' },
    { key: 'installationDate', label: 'FROM DATE' },
    { key: 'max_station_time', label: 'LAST COMMUNICATION DATE' },
    { key: 'status', label: 'STATUS' }
  ]

  @observable filter = 'station';
  @observable tag = '';
  @observable station = '';

  @observable cols = [];
  @observable rows = [];
  @observable tabularData = []
  @observable statusDays = 1;

  dispose
  componentWillMount() {
    const { tagStore, stationStore, mapStore } = this.props;
    if (!tagStore.items.length) tagStore.fetchItems();
    if (!stationStore.items.length) stationStore.fetchItems();
    if (!mapStore.stations.length && !mapStore.loadingMarkers) mapStore.fetchMapMarkers();
    setTimeout(() => {
      ADMINISTRATIVE_DIVISIONS.forEach(item => {
        fetch(item.file).then(res => res.json()).then(res => this.setState({ [item.name]: res }));
      })
      // fetch('geojson/bd_district.json').then(res => res.json()).then(districts => this.setState({ districts }));
      // fetch('geojson/basin.json').then(res => res.json()).then(basins => this.setState({ basins }));
      // fetch('geojson/bd_province.json').then(res => res.json()).then(provinces => this.setState({ provinces }));
    }, 0);
    this.dispose = autorun(() => {
      if (!!stationStore.items.length && !!mapStore.stations.length) {
        this.populateStations();
        !!this.dispose && this.dispose();
      }
    })
  }

  statusOptions = [
    { status: 'No Communication', color: 'RED' },
    { status: 'Normal', color: 'GREEN' },
    { status: 'QC Error', color: 'YELLOW' }]

  @action populateStations = () => {
    const { mapStore, stationStore } = this.props;

    const stations = stationStore.items.map((station) => {
      const district = station.meta_data.find(item => item.name === 'District')
      const upazila = station.meta_data.find(item => item.name === 'Upazila')
      const installationDate = station.meta_data.find(item => item.name === 'Installation Date');

      let monitoringStation = mapStore.stationsJson.find(item => +item.id === +station.id);
      return ({
        id: station.id,
        name: station.name,
        identifier: station.identifier,
        district: district ? district.value : '',
        upazila: upazila ? upazila.value : '',
        latitude: station.latitude,
        longitude: station.longitude,
        tags: station.tags,
        installationDate: installationDate ? installationDate.value : '',
        monitoringStation,
        color: !!monitoringStation ? monitoringStation.color : '',
        max_station_timestamp: !!monitoringStation && !!monitoringStation.max_station_timestamp ? getDisplayDate(monitoringStation.max_station_timestamp, { format: 'YYYY-MM-DDTHH:mm:ss' }) : '',
        max_station_time: !!monitoringStation && !!monitoringStation.max_station_time ? getDisplayDate(monitoringStation.max_station_time, { format: 'YYYY-MM-DDTHH:mm:ss' }) : '',
      });
    })

    this.setState({ stations });
  };


  @action onChangeFilter = (e) => {
    this.filter = e.target.value;
    this.tag = '';
    this.station = '';
  };

  @action onChangeTag = (e) => {
    this.tag = e.target.value;
    this.assignRowsAndColumns();
  };

  @action onChangeStation = (e) => {
    this.station = e.target.value;
    this.assignRowsAndColumns();
  };

  @action exportPDF = (e, format) => {
    e.preventDefault();
    let csv = ['SN,NAME,IDENTIFIER,DISTRICT,UPAZILA,LATITUDE,LONGITUDE,FROM DATE,TO DATE,STATUS'];
    this.state.filteredStations.map((station, i) => {
      // let color = station.color === 'YELLOW' ? 'YELLOW' : moment(station.max_station_timestamp).valueOf() > moment().subtract(this.statusDays, 'days').valueOf() ? 'GREEN' : 'RED';
      csv.push([
        i + 1,
        station.name ? station.name.replaceAll(",", "_") : '',
        station.identifier,
        station.district ? station.district.replaceAll(",", "_") : '',
        station.upazila ? station.upazila.replaceAll(",", "_") : '',
        station.latitude,
        station.longitude,
        station.installationDate ? station.installationDate.replaceAll(",", "_") : '',
        !!station.monitoringStation && !!station.monitoringStation.max_station_time ? station.monitoringStation.max_station_time.split('T')[0] : '',
        this.statusOptions.find(option => option.color === station.color).status
      ].join(','));
    });
    this.props.reportingTemplateStore.downloadReport(
      csv.join('\n'),
      format,
      { orientation: 'Landscape', report_name: 'Monitoring Table' }
    );
  }

  render() {
    const { tagStore, stationStore, mapStore } = this.props;
    // const status_time = storage.preference.get().status_time || 'timestamp';
    const data = this.state.filteredStations
      .sort((a, b) => a.name < b.name ? -1 : 1)
      .map((item, index) => {
        let status = this.statusOptions.find(option => option.color === item.color).status
        return Object.assign({}, item, {
          sn: index + 1,
          status,
          max_station_time: !!item.max_station_time ? item.max_station_time.split('T')[0] : '',
        });
      });

    return (
      <div>
        <MapFilterGroup
          statusProps={{ statusDays: this.statusDays, onChangeStatusDays: e => this.statusDays = e.target.value }}
          tagsProps={{ tags: tagStore.items, isLoading: tagStore.isLoading }}
          divisionProps={{
            options: [
              { label: 'All', value: 'all' },
              ...ADMINISTRATIVE_DIVISIONS.map(item => ({
                label: item.label,
                value: item.name,
                geoJson: this.state[item.name],
                key: item.key
              }))
              // { label: 'Province', value: 'province', geoJson: this.state.provinces, key: 'Name' },
              // { label: 'District', value: 'district', geoJson: this.state.districts, key: 'DIST_NAME' },
              // { label: 'Basin', value: 'basin', geoJson: this.state.basins, key: 'BASIN_NAME' },
            ],
          }}
          stationProps={{
            stations: this.state.stations,
            // stations: mapStore.stationsJson,
            noLatLng: true,
            setFilteredStations: stations => this.setState({ filteredStations: stations }),
            setSelectedBoundary: selectedBoundaryFeature => this.selectedBoundaryFeature = selectedBoundaryFeature
          }}
        />
        {(tagStore.isLoading || stationStore.isLoading || mapStore.loadingMarkers) && !this.state.filteredStations.length && <Spinner />}
        {!!this.state.filteredStations.length && <button className='button' onClick={(e) => this.exportPDF(e, "PDF")}>Print</button>}
        {!!this.state.filteredStations.length && <button className='button' onClick={(e) => this.exportPDF(e, "CSV")}>Download CSV</button>}
        {!!this.state.filteredStations.length &&
          <DataTable data={data} columns={this.columns}
            slug={'/monitoring/tabular'} sortRow={items => items.sort((a, b) => +a.sn < +b.sn ? -1 : 1)} paginate />}
      </div>
    );
  }
}

export default MonitoringTabular;



// WEBPACK FOOTER //
// ./src/components/Monitoring/MonitoringTabular2.js